import { pxToRem } from '../../../../utils';
export var carouselPaddlesContainerStyles = {
  root: function root(_ref) {
    var v = _ref.variables;
    return {
      display: 'flex',
      width: pxToRem(v.width),
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'absolute',
      top: 0,
      right: 0,
      left: 0,
      bottom: 0
    };
  }
};